import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { MainTitle, Spinner } from '../../../common/index.jsx';
import { EduCourseDetailPage as EduCourseDetailContent } from '../../../common/FriEdu/EduCourseDetailPage.jsx';
import { useGetEduCourseDetailForPublicQuery } from '../../../../redux/services/eduCourses.jsx';

export const FriEduDetailPage = () => {
  const { id } = useParams();
  const { t } = useTranslation();

  const {
    data: courseDetail,
    isLoading,
    refetch,
  } = useGetEduCourseDetailForPublicQuery(id);

  useEffect(() => {
    document.title = 'FRI.edu - ' + t('Detail kurzu');
  }, [t]);

  return isLoading ? (
    <Spinner />
  ) : (
    <>
      <MainTitle
        backAction={true}
        title={`${t('FRI.edu kurz')}: ${courseDetail.name}`}
      />

      <EduCourseDetailContent
        courseDetail={courseDetail}
        showDatesSection={true}
        isAdmin={false}
        isAuthor={false}
        canUpdate={false}
        onRefetchCourses={refetch}
      />
    </>
  );
};

export default FriEduDetailPage;
